import getErrorKey from '../../components/address/getErrorKey';

const noSpecialChars = fieldName => (value) => {
  if (!value) return;
  
  const errorKey = getErrorKey(fieldName, 'errors.formFields.noSpecial');
  const containsSpecialChars = /[^-,a-zA-Z0-9 ]/.test(value);
  
  return containsSpecialChars ? errorKey : undefined;
};

export default noSpecialChars;
